/// <reference types="./edit_line.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function edit_line() {
  return $svg.view(
    12,
    14,
    "<path d=\"M2.276 9.66664L9.03733 2.90531L8.09467 1.96264L1.33333 8.72398V9.66664H2.276ZM2.82867 11H0V8.17131L7.62333 0.547974C7.74835 0.422994 7.91789 0.352783 8.09467 0.352783C8.27144 0.352783 8.44098 0.422994 8.566 0.547974L10.452 2.43397C10.577 2.55899 10.6472 2.72853 10.6472 2.90531C10.6472 3.08208 10.577 3.25162 10.452 3.37664L2.82867 11V11ZM0 12.3333H12V13.6666H0V12.3333Z\" fill=\"currentColor\"/>",
  );
}
